import { AgentRef, AgentRunRef } from "@/types/agent-summary"

/**
 * Server-pushed custom-agent events (BroadcastService MESSAGE_PROACTIVE_AGENT):
 * one of the user's agents started or finished a run. The payload only names
 * the agent and run; consumers refetch what they show.
 */
export interface ProactiveAgentEvent {
  event: "run_started" | "run_finished"
  agent_ref: AgentRef
  run_ref: AgentRunRef
}

type Listener = (event: ProactiveAgentEvent) => void

const listeners = new Set<Listener>()

export function dispatchProactiveAgentEvent(event: ProactiveAgentEvent) {
  listeners.forEach((listener) => listener(event))
}

export function onProactiveAgentEvent(listener: Listener) {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}
